import { type MatrixValueGroup } from '../../../v1';
import { Repository } from '../repository';
import { MatrixValue, type MatrixValueProps } from './entity';

export class MatrixValues extends Repository<MatrixValue> {
    updateOrAppendAll(values: MatrixValueProps[]): void {
        const touchedGroups = new Set(values.map((v) => v.group));
        const usedIds = new Set(values.map((v) => v.id));

        const existing = values.filter((v) => this.getById(v.id));
        const created = values.filter((v) => !existing.includes(v));
        const deleted = this.getAll()
            .filter((d) => touchedGroups.has(d.group) && !usedIds.has(d.id))
            .map((d) => d.id);

        existing.forEach((e) => this.getById(e.id)?.update(e));
        created
            .map((c) => MatrixValue.new(c))
            .forEach((c) => {
                this.add(c);
            });
        deleted.forEach((d) => {
            this.remove(d);
        });
    }

    getAllByGroup(group: MatrixValueGroup): MatrixValue[] {
        return this.getAll().filter(
            (matrixValue) => matrixValue.group === group,
        );
    }
}
